import { useCallback, useContext } from "react";
import { ProfileFilterContext } from "../store/profile-filter-context";

export default function useProfileFilter() {
  const { selectedProfileIds, setSelectedProfileIds } =
    useContext(ProfileFilterContext);
  const isFilterActive = selectedProfileIds.length > 0;

  const matchesProfileFilter = useCallback(
    (profileId: number | undefined | null) => {
      if (!isFilterActive) return true;
      if (profileId === undefined || profileId === null) return false;
      return selectedProfileIds.includes(profileId);
    },
    [isFilterActive, selectedProfileIds],
  );

  return {
    selectedProfileIds,
    setSelectedProfileIds,
    isFilterActive,
    matchesProfileFilter,
  };
}
